module.exports = __webpack_public_path__ + "img/fastvaluedeal-title-image.5002647f.webp";